import React from 'react'
import styles from "../Fees/Fees.module.scss";

const TermsConditions = () => {
    return (
        <div className={styles.fee_content}>
            <div className={styles.legal_header}>
                <h1>STBL Platform Terms & Conditions</h1>

            </div>

            <div className={styles.legal_section}>
                <h3>1. Overview <span>General</span></h3>
                <p>These Terms govern your access to and use of the STBL Platform. By creating an account, you agree to these Terms.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>2. Eligibility <span>Requirements</span></h3>
                <p>You must meet the following criteria to use the Platform:</p>
                <ul>
                    <li>Be at least 18 years old</li>
                    <li>Complete identity verification</li>
                    <li>Not be located in a restricted jurisdiction</li>
                    <li>Not be subject to sanctions</li>
                </ul>
                <p>We reserve the right to refuse service at our discretion.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>3. Nature of the Platform <span>Services</span></h3>
                <p>STBL provides the following services:</p>
                <ul>
                    <li>Tokenized gold and silver products</li>
                    <li>Marketplace trading</li>
                    <li>Redemption functionality</li>
                    <li>Wallet functionality</li>
                    <li>Peer-to-peer transactions</li>
                </ul>
                <div className={styles.legal_footer}>
                    <p>STBL is not a bank. Digital asset balances are not insured unless explicitly stated.</p>
                </div>
            </div>

            <div className={styles.legal_section}>
                <h3>4. Account Registration & KYC <span>Identity</span></h3>
                <p>You agree to provide accurate information, complete identity verification, and update changes promptly. We may suspend accounts pending verification.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>5. Tokenized Assets <span>Assets</span></h3>
                <p>STBL tokens represent interests in underlying physical metals held by custodians. Redemption rights are subject to thresholds, verification, fees, and operational constraints.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>6. Trading & Marketplace <span>Market</span></h3>
                <p>Marketplace transactions are subject to pricing spreads and transaction fees. All transactions are final once executed.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>7. Fees <span>Costs</span></h3>
                <p>You agree to pay all applicable fees disclosed in the Fee Schedule. Fees may change with notice.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>8. Risk Disclosure <span>Risk</span></h3>
                <p>You acknowledge that precious metals fluctuate in value and blockchain networks may experience congestion. You assume all market risk.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>9. Prohibited Use <span>Compliance</span></h3>
                <p>The Platform may not be used for money laundering, fraud, or illegal activities. We may freeze or terminate accounts for violations.</p>
            </div>

            <div className={styles.legal_section}>
                <h3>10. Suspension & Termination <span>Policy</span></h3>
                <p>We may suspend or terminate your account if required by law or if suspicious activity is detected.</p>
            </div>

            <div className={styles.legal_footer}>
                <p>We may update these terms from time to time. Changes will be posted on this page, and continued use of the Platform constitutes acceptance of the updated Terms.</p>
            </div>
        </div>
    )
}

export default TermsConditions
